var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('button',{staticClass:"up-arrow up",on:{"click":_vm.smoothScroll}}),_c('button',{staticClass:"up-btn up",on:{"click":_vm.smoothScroll}},[_vm._v("Наверх")])])}
var staticRenderFns = []

export { render, staticRenderFns }